<template>
  <v-textarea
    id="textarea-limit-height"
    :class="compClass"
    :label="label"
    :placeholder="placeholder"
    :type="type"
    :disabled="disabled"
    :readonly="readonly"
    :auto-grow="autoGrow"
    :rows="rows"
    :counter="readonly ? null : maxLength"
    :hide-details="hideDetails"
    v-model.trim="elValue"
    @blur="onBlur"
    @focus="onFocus"
    v-validate="validateRules"
    :data-vv-name="validateName"
    :error-messages="errorMessages"
    :data-vv-validate-on="required || counter ? 'input' : 'change'"
    :append-outer-icon="appendOuterIcon"
    @click:append-outer="clickAppendOuter"
    persistent-placeholder
    :autofocus="autofocus"
  >
    <el-tooltip
      slot="append"
      v-if="tooltip"
      :tooltip="tooltip"
      :tooltip-key="tooltipKey"
      absolute
    />
    <template slot="append-outer">
      <slot name="append-outer"></slot>
    </template>
    <template slot="prepend">
      <slot name="prepend"></slot>
    </template>
  </v-textarea>
</template>

<script>
export default {
  name: 'ElTextarea',
  props: {
    classP: String,
    label: String,
    placeholder: { type: String, default: ' ' },
    type: String,
    tooltip: String,
    tooltipKey: { type: String, default: '' },
    counter: [Number, String],
    hideDetails: [Boolean, String],
    required: Boolean,
    need: Boolean,
    date: Boolean,
    value: [String, Number],
    disabled: Boolean,
    readonly: Boolean,
    validateKey: String,
    autoGrow: { type: Boolean, default: true },
    rows: { type: Number, default: 1 },
    appendOuterIcon: String,
    autofocus: { type: Boolean, default: false },
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    validateName() {
      return this.validateKey ?? this.label
    },
    validateMessages() {
      return {
        'field may not be greater than': this.$t(
          'Viršytas simbolių skaičius {maxLength}',
          { maxLength: this.maxLength }
        ),
        'field is required': this.$t('Laukas privalomas'),
      }
    },
    validateRules() {
      let rule = ''
      rule = this.required ? 'required' : ''
      rule += this.date ? (rule ? '|' : '') + 'date_format:yyyy-MM-dd' : ''
      //rule += this.counter ? (rule ? '|' : '') + `max:${this.maxLength}` : ''
      return rule
    },
    errorMessages() {
      const messages = this.errors.collect(this.validateName)
      let message = messages[0]
      if (messages.length > 0) {
        const key = Object.keys(this.validateMessages).find(item =>
          messages[0].includes(item)
        )
        return this.validateMessages[key]
      }

      return this.overError
    },
    maxLength() {
      return this.counter
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} labelPatch`
    },
    dbCount() {
      return this.value ? this.value.length : 0
    },
    countOver() {
      return !!this.counter && this.dbCount > this.counter
    },
    overError() {
      return this.countOver
        ? this.$t('Viršytas simbolių skaičius {curLength}/{maxLength}', {
            curLength: this.dbCount,
            maxLength: this.counter,
          })
        : null
    },
  },
  methods: {
    onBlur(e) {
      if (this.countOver) {
        let finalText = this.value.toString()
        while (finalText.length > this.counter) {
          finalText = finalText.slice(0, -1)
        }
        this.elValue = finalText
      }
      this.$emit('blur', e.target.value)
    },
    onFocus(e) {
      this.$emit('focus', e.target.value)
    },
    clickAppendOuter() {
      this.$emit('clickAppendOuter')
    },
    countLineBreaks(text) {
      return (String(text).match(/\n/g) || '').length
    },
  },
}
</script>

<style lang="scss" scoped></style>
